import { RouteRecordRaw } from 'vue-router';

import {
  useAccountStore,
  useEditAccountStore,
  useRootStore,
} from '@/store';

// アカウント関連
export const accountRoutes: Array<RouteRecordRaw> = [
  {
    name: 'Account',
    component: () => import('@/components/pages/account/index.vue'),
    path: '/account',
    meta: {
      title: 'アカウント',
      requiredAuthority: 'ADMIN_USERS',
    },
  },
  {
    name: 'AccountAdd',
    path: '/account/add',
    component: () => import('@/components/pages/account/add/index.vue'),
    meta: {
      title: 'アカウント登録',
      requiredAuthority: 'EDIT_ADMIN_USERS',
    },
    beforeEnter: (to, from, next) => {
      if (from.name === 'AccountAddConfirm' || from.name === 'AccountId') {
        next();
      } else {
        useAccountStore().$reset();
        useRootStore().$reset();
        next();
      }
    },
  },
  {
    name: 'AccountAddConfirm',
    path: '/account/add/confirm',
    component: () => import('@/components/pages/account/add/confirm/index.vue'),
    meta: {
      title: 'アカウント登録確認',
      requiredAuthority: 'EDIT_ADMIN_USERS',
    },
    beforeEnter: (to, from, next) => {
      const store = useAccountStore();
      const { form } = store;

      if (from.path === '/account/add' && form != null) {
        next();
      } else {
        next({ path: '/account/add', replace: true });
      }
    },
  },
  {
    name: 'AccountId',
    component: () => import('@/components/pages/account/detail/index.vue'),
    path: '/account/:id',
    meta: {
      title: 'アカウント詳細',
      requiredAuthority: 'ADMIN_USERS',
    },
  },
  {
    name: 'AccountEdit',
    component: () => import('@/components/pages/account/detail/edit/index.vue'),
    path: '/account/:id/edit',
    meta: {
      title: 'アカウント編集',
      requiredAuthority: 'EDIT_ADMIN_USERS',
    },
    beforeEnter: async (to, from, next) => {
      const id = to.params.id.toString();

      const editAccountStore = useEditAccountStore();

      // 確認画面以外から遷移した場合はstoreに詳細APIを叩いた結果をセットし、formをリセットする
      if (from.name !== 'AccountEditConfirm') {
        await editAccountStore.setInitData(id);
        editAccountStore.$resetForm();
        useRootStore().$reset();
      }
      next();
    },
  },
  {
    name: 'AccountEditConfirm',
    component: () => import('@/components/pages/account/detail/edit/confirm/index.vue'),
    path: '/account/:id/edit/confirm',
    meta: {
      title: 'アカウント編集確認',
      requiredAuthority: 'EDIT_ADMIN_USERS',
    },
    beforeEnter: (to, from, next) => {
      const id = to.params.id.toString();
      const store = useEditAccountStore();
      const { form } = store;

      if (from.path === `/account/${id}/edit` && form != null) {
        next();
      } else {
        next({ path: `/account/${id}`, replace: true });
      }
    },
  },
];
